import {Routes, RouterModule}  from '@angular/router';
import {Pages} from './pages.component';
import {ModuleWithProviders} from '@angular/core';
import {LoginGuard} from "../filter/app.guard";
import {AdminGuard} from "../filter/app.adminGuard";

export const routes:Routes = [
    {
        path: 'login',
        loadChildren: 'app/pages/login/login.module#LoginModule',
    },
    {
        path: '',
        loadChildren: 'app/pages/login/login.module#LoginModule'
    },
    {
        path: 'forgot-password',
        loadChildren: 'app/pages/forgotPassword/forgotPassword.module#ForgotPasswordModule'
    },
    {
        path: 'signup',
        loadChildren: 'app/pages/signUp/signUp.module#SignUpModule'
    },
    {
        path: 'reset-password',
        loadChildren: 'app/pages/resetPassword/resetPassword.module#ResetPasswordModule'
    },
    {
        path: 'set-password',
        loadChildren: 'app/pages/setPassword/setPassword.module#SetPasswordModule'
    },
    {
        path: 'email-verification',
        loadChildren: 'app/pages/emailVerificationConfirmation/emailVerificationConfirmation.module#EmailVerificationModule'
    },
    {
        path: '',
        component: Pages,
        children: [
            {
                path: '',
                redirectTo: 'createPurchaseOrder',
                pathMatch: 'full'
            },
            {
                path: 'createPurchaseOrder',
                loadChildren: './createPurchaseOrder/createPurchaseOrder.module#createPurchaseOrderModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'addVendor',
                loadChildren: './addVendor/addVendor.module#addVendorModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'editVendor',
                loadChildren: './editVendor/editVendor.module#editVendorModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'viewVendors',
                loadChildren: './vendor/vendor.module#VendorModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'viewUsers',
                loadChildren: './viewUsers/viewUsers.module#viewUsersModule',
                canActivate: [LoginGuard, AdminGuard]
            },
            {
                path: 'viewExpenses',
                loadChildren: './viewExpenseModel/viewExpenseModel.module#viewExpenseModelModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'viewTermsAndConditions',
                loadChildren: './viewTermsAndConditions/viewTermsAndConditions.module#viewTermsAndConditionsModule',
                canActivate: [LoginGuard, AdminGuard]
            },
            {
                path: 'viewItems',
                loadChildren: './item/item.module#itemModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'viewCategoryItems',
                loadChildren: './viewCategoryItems/viewCategoryItems.module#viewCategoryItemsModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'viewReports',
                loadChildren: './viewReports/viewReports.module#viewReportsModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'viewCategoryVendors',
                loadChildren: './viewCategoryVendors/viewCategoryVendors.module#viewCategoryVendorsModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'paymentDetails',
                loadChildren: './paymentDetails/paymentDetails.module#paymentDetailsModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'receivedItems',
                loadChildren: './receivedItems/receivedItems.module#receivedItemsDetailsModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'addItem',
                loadChildren: './addItem/addItem.module#addItemModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'addTermsAndCondition',
                loadChildren: './addT&C/addT&C.module#addTermsAndConditionModule',
                canActivate: [LoginGuard, AdminGuard]
            },
            {
                path: 'editTermsAndCondition',
                loadChildren: './editT&C/editT&C.module#editTermsAndConditionModule',
                canActivate: [LoginGuard, AdminGuard]
            },
            {
                path: 'editItem',
                loadChildren: './editItem/editItem.module#editItemModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'purchaseOrder',
                loadChildren: './purchaseOrder/purchaseOrder.module#purchaseOrderModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'createPurchaseOrder',
                loadChildren: './createPurchaseOrder/createPurchaseOrder.module#createPurchaseOrderModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'editPurchaseOrder',
                loadChildren: './editPurchaseOrder/editPurchaseOrder.module#editPurchaseOrderModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'settings',
                loadChildren: './settings/settings.module#SettingsModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'viewCategories',
                loadChildren: './viewTags/viewTags.module#ViewTagsModule',
                canActivate: [LoginGuard, AdminGuard]
            },
            {
                path: 'almirah',
                loadChildren: './almirah/almirah.module#almirahModule',
                canActivate: [LoginGuard, AdminGuard]
            },
            {
                path: 'viewTemplates',
                loadChildren: './viewTemplates/viewTemplates.module#viewTemplatesModule',
                canActivate: [LoginGuard, AdminGuard]
            },
            {
                path: 'viewUnits',
                loadChildren: './viewUnits/viewUnits.module#viewUnitsModule',
                canActivate: [LoginGuard, AdminGuard]
            },
            {
                path: 'addAlmirah',
                loadChildren: './addAlmirah/addAlmirah.module#addAlmirahModule',
                canActivate: [LoginGuard, AdminGuard]
            },
            {
                path: 'addExpense',
                loadChildren: './addExpenseModel/addExpenseModel.module#addExpenseModelModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'editExpense',
                loadChildren: './editExpenseModel/editExpenseModel.module#editExpenseModelModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'addTemplate',
                loadChildren: './addTemplate/addTemplate.module#addTemplateModule',
                canActivate: [LoginGuard, AdminGuard]
            },
            {
                path: 'addCompanyUnit',
                loadChildren: './addCompanyUnit/addCompanyUnit.module#addCompanyUnitModule',
                canActivate: [LoginGuard, AdminGuard]
            },
            {
                path: 'editCompanyUnit',
                loadChildren: './editCompanyUnit/editCompanyUnit.module#editCompanyUnitModule',
                canActivate: [LoginGuard, AdminGuard]
            },
            {
                path: 'editTemplate',
                loadChildren: './editTemplate/editTemplate.module#editTemplateModule',
                canActivate: [LoginGuard, AdminGuard]
            },
            {
                path: 'sendMail',
                loadChildren: './sendMail/sendMail.module#sendMailModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'editAlmirah',
                loadChildren: './editAlmirah/editAlmirah.module#editAlmirahModule',
                canActivate: [LoginGuard, AdminGuard]
            },
            {
                path: 'changePassword',
                loadChildren: './Profile/profile.module#ProfileModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'inactive-user',
                loadChildren: './InActiveUser/inActiveUser.module#inActiveUserModule',
                canActivate: [LoginGuard, AdminGuard]
            },
            {
                path: 'email',
                loadChildren: './email/email.module#EmailModule',
                canActivate: [LoginGuard, AdminGuard]
            },
            {
                path: 'addUser',
                loadChildren: './addUser/addUser.module#AddUserModule',
                canActivate: [LoginGuard, AdminGuard]
            },
            {
                path: 'editUser',
                loadChildren: './editUser/editUser.module#editUserModule',
                canActivate: [LoginGuard, AdminGuard]
            },
            {
                path: 'investor',
                loadChildren: './investor/investor.module#InvestorModule',
                canActivate: [LoginGuard, AdminGuard]
            },
            {
                path: 'investor-profile',
                loadChildren: './investorProfile/investorProfile.module#InvestorProfileModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'manage-offering',
                loadChildren: './manageOfferings/offerings.module#OfferingsModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'add-offering',
                loadChildren: './addOffering/addOffering.module#AddOfferingModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'browse-offering',
                loadChildren: './browseOfferings/browseOfferings.module#BrowseOfferingsModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'edit-offering',
                loadChildren: './editOffering/editOffering.module#EditOfferingModule',
                canActivate: [LoginGuard]
            },
            {
                path: 'offering',
                loadChildren: './offering/offering.module#OfferingModule',
                canActivate: [LoginGuard]},

        ]
    }
];

export const routing:ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// ./src/app/pages/pages.routing.ts